import { Box, Card, Grid, Typography } from '@mui/material';
import React from 'react';

import { FaOptionIcon } from '@europrocurement/l2d-icons';
import { faUserTie } from '@fortawesome/pro-duotone-svg-icons';
import { useTheme } from '@mui/system';
import { OptionType } from '../../atoms';

export type DirigeantPM = {
    entreprise: {
        denomination: string;
        roleEntreprise: OptionType;
        siren?: string;
        autreIdentifiantEtranger?: string;
    };
    adresse: string;
};

export type DirigeantPMWidgetCallbackArgs = (dirigeantPM: DirigeantPM, index: number) => void;

export type DirigeantPMWidgetType = {
    dirigeantPM: DirigeantPM;
    actions?: Array<{
        name: string;
        icon?: React.ReactNode | React.FunctionComponent;
        tooltip?: string;
        text?: string;
        onClick: DirigeantPMWidgetCallbackArgs;
    }>;
    index?: number;
};

// exemple de style sur DisplayFile

export const DirigeantPMWidget: React.FunctionComponent<DirigeantPMWidgetType> = function ({
    dirigeantPM,
    actions,
    index = -1,
}: DirigeantPMWidgetType) {
    const theme = useTheme();
    return (
        <Card sx={{ padding: '10px', cursor: 'pointer', margin: '15px 0' }}>
            <Grid
                container
                sx={{
                    marginLeft: '0px',
                }}
            >
                <Grid
                    item
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        width: '100%',
                        paddingLeft: '0px',
                    }}
                >
                    <Box
                        display="flex"
                        flexDirection="row"
                        gap="10px"
                        sx={{
                            margin: '0 12px 0',
                        }}
                    >
                        <Box
                            data-testid="test-id-status-color-box"
                            sx={{
                                margin: '0px',
                                padding: '10px',
                                borderRadius: '10px',
                                fontSize: '25px',
                                maxHeight: '65px',
                                backgroundColor: 'rgba(66,221,245,0.2)',
                            }}
                        >
                            <FaOptionIcon
                                data-testid="test-id-mimetype-icone"
                                icon={faUserTie}
                                color={theme.palette.primary.main}
                                sx={{ fontSize: '33px' }}
                            />
                        </Box>
                        <Box sx={{ padding: '0 10px', minWidth: '150px' }}>
                            <Typography
                                variant="h5"
                                sx={{ fontWeight: 'bold' }}
                            >
                                {dirigeantPM.entreprise.denomination}
                            </Typography>
                            <Typography variant="h5">
                                {dirigeantPM.entreprise.siren ||
                                    dirigeantPM.entreprise.autreIdentifiantEtranger}
                            </Typography>
                            <Typography variant="h5">
                                {dirigeantPM.entreprise.roleEntreprise?.label}
                            </Typography>
                            <Typography variant="h6">{dirigeantPM.adresse}</Typography>
                        </Box>
                    </Box>
                    <Box
                        display="flex"
                        flexDirection="row"
                        gap="10px"
                        sx={{
                            margin: '0 0 0 auto',
                        }}
                    >
                        {actions
                            ? actions.map((action, key) => (
                                  <Box
                                      title={action.tooltip}
                                      data-testid={`test-id-${key}-handleClick-button`}
                                      onClick={() => action.onClick(dirigeantPM, index)}
                                      role="button"
                                      key={action.name}
                                  >
                                      {action.icon || action.text}{' '}
                                  </Box>
                              ))
                            : null}
                    </Box>
                </Grid>
            </Grid>
        </Card>
    );
};
